// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseURL: 'https://www.nubefrigo.com/api',
  clientBaseURL: 'https://www.nubefrigo.com',
  //baseURL: 'http://localhost:8148/api',
  //clientBaseURL: 'http://localhost:8148/',
  rollbarToken: 'c48ece342d344fd2baf094ee93b9f1e76802a5e04bc2169e756d9395420011a5c6a52ea788bf056b1b56a6a4672241d1'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
